module.exports = __webpack_public_path__ + "static/img/sample-code.b90271d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/novel-coronavirus/sample-code.png
// module id = WgWA
// module chunks = 1